import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IBlog, IBlogCategoty } from "src/@types/blog";
import { getBlogPostsAsync, getBlogCategoriesAsync } from "./actions";
import { BlogState } from "./slice";

type ActionReducerMapBuilderWithBlogState = ActionReducerMapBuilder<BlogState>;

export const getBlogPostsReducer = (
  builder: ActionReducerMapBuilderWithBlogState
) => {
  builder.addCase(getBlogPostsAsync.pending, (state) => {
    state.isLoadingPosts = true;
  });

  builder.addCase(
    getBlogPostsAsync.fulfilled,
    (state, actions: PayloadAction<IResponseWithPagination<IBlog>>) => {
      state.isLoadingPosts = false;
      state.posts = actions.payload;
    }
  );

  builder.addCase(getBlogPostsAsync.rejected, (state) => {
    state.isLoadingPosts = false;
    state.posts = null;
  });
};

export const getBlogCategoriesReducer = (
  builder: ActionReducerMapBuilderWithBlogState
) => {
  builder.addCase(getBlogCategoriesAsync.pending, (state) => {
    state.isLoadingCategories = true;
  });

  builder.addCase(
    getBlogCategoriesAsync.fulfilled,
    (state, actions: PayloadAction<IBlogCategoty[]>) => {
      state.isLoadingCategories = false;
      state.categories = actions.payload;
    }
  );

  builder.addCase(getBlogCategoriesAsync.rejected, (state) => {
    state.isLoadingCategories = false;
    state.categories = null;
  });
};
